<swiper-container
  #slider
  class="w-full"
  init="false">
  @for (slide of slideItems(); track slide) {
  <swiper-slide [attr.data-hash]="slide.hash() || null">
    <ng-container [ngTemplateOutlet]="slide.templateRef"></ng-container>
  </swiper-slide>
  }
</swiper-container>

@if (pagination()) {
<div
  [id]="sliderId"
  class="custom-pagination flex items-center justify-center"></div>
}
